import actions from '../actions';

const {
  SET_PROJECTS
} = actions;

/*
 * Reducers
 */

export function projects(state = {}, action) {
  switch (action.type) {

  case SET_PROJECTS:
    return action.projects;

  default:
    return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/project.js